exports.EvaluationMethods = {
  'CUT/CUP': 'CUT/CUP',
  'CP': 'CP',
  'RSP': 'RSP'
};